import { useState, useEffect } from "react";
import ButtonFullWidth from "../ButtonFullWidth";
import {
    faCheck,
    faTimes,
    faRotateRight,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";

export default function S2Registration({
    handlePrevStep,
    handleNextStep,
    s1Form,
}) {
    const [isLoading, setIsLoading] = useState(true);
    const [success, setSuccess] = useState(false);
    const [message, setMessage] = useState(false);

    const handleRequest = () => {
        setIsLoading(true);
        
        let reportingUrl;
        let fecthRequest;
        let headers;

        if (s1Form.vendor === "SBM") {
            reportingUrl =
                import.meta.env.VITE_JUNGLEDRUM +
                "report?start_date=2023-06-12&end_date=" +
                new Date().toISOString();

            headers = {
                "x-api-key": s1Form.apiKey,
                "Content-Type": "application/json",
            };
        } else if (s1Form.vendor === "Bulletin" || s1Form.vendor === "A2POne") {
            fecthRequest = {
                api_key: s1Form.apiKey,
                vendor: s1Form.vendor,
            };

            headers = {
                "Content-Type": "application/json",
            };

            reportingUrl = import.meta.env.VITE_CHECK_BULLETIN_KEY;
        } else {
            // Setting up request for replies from surveys
            reportingUrl =
                import.meta.env.VITE_MESSAGEMEDIA +
                "v2-preview/reporting/messages/detail";

            const authString = s1Form.apiKey + ":" + s1Form.apiSecret;
            let base64AuthString;

            if (
                typeof window !== "undefined" &&
                typeof window.btoa === "function"
            ) {
                base64AuthString = window.btoa(authString);
            } else {
                const buffer = Buffer.from(authString, "utf-8");
                base64AuthString = buffer.toString("base64");
            }

            headers = {
                Authorization: "Basic " + base64AuthString,
                "Content-Type": "application/json",
            };

            // Sending request
            const requestBody = {
                start_date: new Date(
                    new Date() - 30 * 24 * 60 * 60 * 1000
                ).toISOString(),
                end_date: new Date().toISOString(),
            };

            fecthRequest = requestBody;
        }
        if (s1Form.vendor === "SBM") {
            axios
                .get(reportingUrl, { headers: headers })
                .then((response) => {
                    console.log("Response:", response.data);

                    setIsLoading(false);
                    setSuccess(true);
                    setMessage(
                        "Your API Key pair has been validated, please press Next to continue."
                    );
                })
                .catch((error) => {
                    console.error("Error:", error);

                    setIsLoading(false);
                    setSuccess(false);
                    setMessage(
                        "Sorry, it appears that your API Key pair is invalid. Please try again."
                    );
                });
        } else {
            axios
                .post(reportingUrl, fecthRequest, { headers: headers })
                .then((response) => {
                    console.log("Response:", response.data);

                    setIsLoading(false);
                    setSuccess(true);
                    setMessage(
                        "Your API Key pair has been validated, please press Next to continue."
                    );
                })
                .catch((error) => {
                    console.error("Error:", error);

                    setIsLoading(false);
                    setSuccess(false);
                    setMessage(
                        "Sorry, it appears that your API Key pair is invalid. Please try again."
                    );
                });
        }
    };
    
    useEffect(() => {
        handleRequest();
    }, []);

    return (
        <>
            <div className="flex items-center justify-center">
                {isLoading ? (
                    <div className="mb-12">
                        <div role="status" className="h-24 w-24">
                            <svg
                                aria-hidden="true"
                                className="animate-spin fill-primary text-gray-200 transition-opacity  duration-500 dark:text-gray-400"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 100 101"
                            >
                                <path
                                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                    fill="currentColor"
                                />
                                <path
                                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                    fill="currentFill"
                                />
                            </svg>
                            <span className="sr-only">Loading...</span>
                        </div>
                    </div>
                ) : (
                    <div
                        role="status"
                        className="relative flex flex-col items-center gap-3"
                    >
                        {success ? (
                            <>
                                <span className="-left-4 flex h-24 w-24 items-center justify-center rounded-full bg-green-200 transition-opacity duration-500">
                                    <div className="h-1/2 w-1/2">
                                        <FontAwesomeIcon
                                            aria-hidden="true"
                                            icon={faCheck}
                                            className="text-green-600"
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                            }}
                                        />
                                    </div>
                                </span>
                                <span className="sr-only">successful</span>
                            </>
                        ) : (
                            <>
                                <span className="-left-4 flex h-24 w-24 items-center justify-center rounded-full bg-red-200 transition-opacity duration-500">
                                    <div className="h-1/2 w-1/2">
                                        <FontAwesomeIcon
                                            aria-hidden="true"
                                            icon={faTimes}
                                            className="text-red-600"
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                            }}
                                        />
                                    </div>
                                </span>
                                <span className="sr-only">unsuccessful</span>
                                <button
                                    type="button"
                                    onClick={() => handleRequest()}
                                >
                                    <p>Retry</p>

                                    <FontAwesomeIcon
                                        aria-hidden="true"
                                        icon={faRotateRight}
                                        className="h-5 w-5"

                                        // className="text-red-600"
                                    />
                                </button>
                            </>
                        )}
                        <p>{message}</p>
                    </div>
                )}
            </div>

            <div className="mx-12 flex gap-x-5">
                <ButtonFullWidth
                    type="button"
                    message="Previous"
                    action={handlePrevStep}
                />
                <ButtonFullWidth
                    type="button"
                    message="Next"
                    action={handleNextStep}
                    applyClassName={!success}
                    className={"border-gray-400 text-gray-400"}
                    disabled={!success}
                />
            </div>
        </>
    );
}
